const langAuthUserActivation = {
	naming: {
		tag: 'auth.user_activation.naming',
		fr: 'Portail Sienna IM',
		en: 'Sienna Investments Portal',
	},
	text_activation_title: {
		tag: 'auth.user_activation.text_activation_title',
		fr: 'Activez simplement votre compte',
		en: 'Simply activate your account',
	},
	text_activation_subtitle: {
		tag: 'auth.user_activation.text_activation_subtitle',
		fr: 'pour profiter pleinement du ',
		en: 'to take full advantage of ',
	},
	btn_activation: {
		tag: 'auth.user_activation.btn_activation',
		fr: 'Cliquez ici pour activer votre compte',
		en: 'Click here to activate your account',
	},
	btn_presentation_player: {
		tag: 'auth.user_activation.btn_presentation_player',
		fr: "Jetez un coup d'œil au",
		en: 'Have a look of',
	},
	text_presentation_title: {
		tag: 'auth.user_activation.text_presentation_title',
		fr: 'Avoir une vision claire de tous vos investissements',
		en: 'Have a clear vision of all your investments',
	},
	text_with_rect_words: {
		tag: 'auth.user_activation.text_with_rect_words',
		fr: '<span class="rectContainer"><span class="rect"></span><span class="rectText">Quand</span>Quand</span> et <span class="rectContainer"><span class="rect"></span><span class="rectText">où</span>où</span> vous le souhaitez.',
		en: '<span class="rectContainer"><span class="rect"></span><span class="rectText">Whenever</span>Whenever</span> and <span class="rectContainer"><span class="rect"></span><span class="rectText">wherever</span>wherever</span> you want.',
	},
	text_presentation_item_1_title: {
		tag: 'auth.user_activation.text_presentation_item_1_title',
		fr: 'Une expérience utilisateur innovante',
		en: 'Innovative user experience',
	},
	text_presentation_item_1_subtitle: {
		tag: 'auth.user_activation.text_presentation_item_1_subtitle',
		fr: "Inspiré par vos méthodes de travail et les meilleures pratiques d'aujourd'hui",
		en: 'Inspired by your ways of working & today’s best practices',
	},
	text_presentation_item_2_title: {
		tag: 'auth.user_activation.text_presentation_item_2_title',
		fr: 'Un lieu unique pour tout ce dont vous avez besoin',
		en: 'A unique place for everything you need',
	},
	text_presentation_item_2_subtitle: {
		tag: 'auth.user_activation.text_presentation_item_2_subtitle',
		fr: "Données d'investissement, documents, performances...",
		en: 'Investments data, documents, performance...',
	},
	text_presentation_item_3_title: {
		tag: 'auth.user_activation.text_presentation_item_3_title',
		fr: 'Optimisé pour les mobiles et toujours à jour',
		en: 'Mobile optimized and always up-to-date',
	},
	text_presentation_item_3_subtitle: {
		tag: 'auth.user_activation.text_presentation_item_3_subtitle',
		fr: "N'hésitez pas à l'utiliser, que ce soit sur votre ordinateur de bureau ou sur votre téléphone portable.",
		en: 'Feel free to use it whether on your desktop or mobile',
	},
	error_activation: {
		tag: 'auth.user_activation.error_activation',
		fr: 'Une erreur s\'est produite. Veuillez contacter le support à <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
		en: 'An error has occurred. Please contact support at <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
	},
	success_activation: {
		tag: 'auth.user_activation.success_activation',
		fr: 'Si un compte activable correspond à l\'adresse {{email}}, vous allez recevoir un mail pour initialiser votre compte. Sinon, contactez le support à <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
		en: 'If an account that can be activated matches the {{email}} address, you will receive an email to initialize your account. Otherwise, please contact support at <a href="mailto:help@sienna-im.com" target="_blank">help@sienna-im.com</a>',
	},
};

export default langAuthUserActivation;
